import { render, staticRenderFns } from "./AlarmButtonPC.vue?vue&type=template&id=2331e018&scoped=true&"
import script from "./AlarmButtonPC.vue?vue&type=script&lang=js&"
export * from "./AlarmButtonPC.vue?vue&type=script&lang=js&"
import style0 from "./AlarmButtonPC.vue?vue&type=style&index=0&id=2331e018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2331e018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VIcon,VMenu})
